module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/2tiDgPv5llS77b8XToCbBD-b14ae3e7303517dd41f620e85e4ebc9d.jpg";